import { render, staticRenderFns } from "./NovemberEvent.vue?vue&type=template&id=1f318aa0&scoped=true"
import script from "./NovemberEvent.vue?vue&type=script&lang=js"
export * from "./NovemberEvent.vue?vue&type=script&lang=js"
import style0 from "./NovemberEvent.vue?vue&type=style&index=0&id=1f318aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f318aa0",
  null
  
)

export default component.exports